// This file is generated.
export var version = '1.54.0';
//# sourceMappingURL=version.js.map